<template>
  <div>
    <b-loading
      :is-full-page="true"
      :active.sync="isFetchingData"
      :can-cancel="false"
    ></b-loading>
    <canvas ref="sellingProfitBarChart"></canvas>
  </div>
</template>

<script>
import axios from "axios";
import Chart from "chart.js";

export default {
  props: ["year", "isAdaptive"],
  mounted() {
    var chart = this.$refs.sellingProfitBarChart;
    var ctx = chart.getContext("2d");
    this.createSellingProfitBarChart(ctx);
  },
  data: () => ({
    isFetchingData: false
  }),
  watch: {
    year() {
      if (this.year) {
        var chart = this.$refs.sellingProfitBarChart;
        var ctx = chart.getContext("2d");
        this.createSellingProfitBarChart(ctx);
      }
    },
    isAdaptive() {
      var chart = this.$refs.sellingProfitBarChart;
      var ctx = chart.getContext("2d");
      this.createSellingProfitBarChart(ctx);
    }
  },
  methods: {
    createSellingProfitBarChart(ctx) {
      this.isFetchingData = true;
      axios
        .get(
          `api/dashboard/annual-monthly-total-profit-by-year/${this.isAdaptive}/${this.year}`
        )
        .then(response => {
          const monthlyQuota = response.data.monthlyQuota;
          const monthlyProfit = response.data;

          return new Chart(ctx, {
            type: "bar",
            data: {
              labels: [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December"
              ],
              datasets: [
                {
                  label: "Monthly Quota",
                  data: [
                    monthlyQuota,
                    monthlyQuota,
                    monthlyQuota,
                    monthlyQuota,
                    monthlyQuota,
                    monthlyQuota,
                    monthlyQuota,
                    monthlyQuota,
                    monthlyQuota,
                    monthlyQuota,
                    monthlyQuota,
                    monthlyQuota
                  ],
                  backgroundColor: "#4FC1E9",
                  borderColor: "#4FC1E9",
                  borderWidth: 1
                },
                {
                  label: "Profit",
                  data: [
                    monthlyProfit.janP,
                    monthlyProfit.febP,
                    monthlyProfit.marP,
                    monthlyProfit.aprP,
                    monthlyProfit.mayP,
                    monthlyProfit.junP,
                    monthlyProfit.julP,
                    monthlyProfit.augP,
                    monthlyProfit.sepP,
                    monthlyProfit.octP,
                    monthlyProfit.novP,
                    monthlyProfit.decP
                  ],
                  backgroundColor: "#3e95cd",
                  borderColor: "#3e95cd",
                  borderWidth: 1
                }
              ]
            },
            options: {
              scales: {
                yAxes: [
                  {
                    ticks: {
                      beginAtZero: true
                    }
                  }
                ]
              }
            }
          });
        })
        .catch(error => console.log(error))
        .then(() => {
          this.isFetchingData = false;
        });
    }
  }
};
</script>
